import { render } from "./team.vue?vue&type=template&id=155b4fee&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"

import "./team.vue?vue&type=style&index=0&id=155b4fee&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155b4fee"]])

export default __exports__